module.exports = __webpack_public_path__ + "img/module_basic.e4b3a659.png";